class PdpButtonGroup extends HTMLElement {
  constructor() {
    super();
    this.whistListBtn = this.querySelector('.whishlist-btn');
    this.findInStoreBtn = this.querySelector('.findinstore-btn');
    this.autoComplete = null;
    this.address1Field = null;
    this.countryCode = document.querySelector('#address-form')?.getAttribute('data-country-code');
  }

  connectedCallback() {
    this.init();
  }

  static get observedAttributes() {
    return ['attribute1', 'attribute2'];
  }

  init() {
    this.addEventListeners();
    this.loadGoogleMapsAPI();
    this.fillInAddress();
  }

  addEventListeners() {
    const whishListAppBtn = document.querySelector('.main-product .wishlist-btn');
    this.whistListBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.querySelector('.whishlist-btn').dataset.customer === 'false') {
        window.location.href = '/account/login';
      } else {
        whishListAppBtn?.click();
      }
    });

    this.findInStoreBtn?.addEventListener('click', () => {
      document.getElementById('storeModal').style.display = 'block';
    });

    let reloaded = false;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-added') {
          const isAdded = mutation.target.dataset.added === 'true';
          if (reloaded) {
            const productData = document.querySelector('#appsflyer-data');
            if (isAdded) {
              this.sendAppsflyerEvent('add_to_wishlist', { price: productData.dataset.price, content_id: productData.dataset.id, content_type: productData.dataset.type, currency: "JPY" });
            }
            // The wishlist app writes data-added twice per click, once on click and
            // once when its API responds, so Braze only takes a real state change.
            const wasAdded = mutation.oldValue === 'true';
            if (isAdded && !wasAdded) this.sendBrazeFavoriteEvent('favorited_product', productData);
            if (!isAdded && wasAdded) this.sendBrazeFavoriteEvent('unfavorited_product', productData);
          }
          if (!reloaded) reloaded = true;
          document.querySelector('.icon-heart_black').style.display = isAdded ? 'block' : 'none';
          document.querySelector('.icon-heart_white').style.display = isAdded ? 'none' : 'block';
        }
      });
    });

    observer.observe(whishListAppBtn, {
      attributes: true,
      attributeFilter: ['data-added'],
      attributeOldValue: true
    });

    document.querySelector('.close')?.addEventListener('click', () => {
      document.getElementById('storeModal').style.display = 'none';
    });

    document.querySelector('#findinstore')?.addEventListener('click', this.handleButtonClick.bind(this));

    document.querySelector('#modal-close')?.addEventListener('click', () => {
      document.getElementById('find-in-stores-modal').style.display = 'none';
      document.body.classList.remove("dialog-open");
    });
  }

  handleButtonClick() {
    const target = document.querySelector('#findinstore');
    let location = target?.dataset.location ? JSON.parse(target.dataset.location) : null;
    const variantId = document.querySelector('product-info')?.dataset.variantId;

    const query = {
      variantId: variantId || 50185122677041,
      lat: location?.lat || null,
      lng: location?.lng || null,
    };

    const queryString = Object.entries(query)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');

      fetch(`${window.levis_api_app_proxy}/shopify-proxy-location/product-list-all-stores?${queryString}`)
        .then((response) => response.json())
        .then((json) => {
          const htmlContent = json.data.content;
          document.getElementById("modal-content").innerHTML = htmlContent;
          document.getElementById("storeModal").style.display = "block";
        })
        .catch((err) => console.log("Error==>", err));
  }

  updateModalContent(data) {
    if (data?.data) {
      const modalContent = document.querySelector("#store-locator-modal .find-in-store-model");
      if (modalContent) {
        modalContent.innerHTML = data.data.content;
      }

      const image = document.querySelector("#store-locator-modal img");
      if (image) {
        const newSrc = "{{ 'google-map.png' | asset_img_url: '15px' }}";
        image.setAttribute('src', newSrc);
      }

      const modal = document.getElementById('store-locator-modal');
      if (modal) {
        modal.style.display = 'block';
      }

      document.body.classList.add("dialog-open");
    }

    // document.querySelector('.loader')?.style.display = 'none';
  }

  handleError(err) {
    // document.querySelector('.loader')?.style.display = 'none';

    const storeList = document.querySelector("#store-locator-modal .store-list");
    if (storeList) {
      storeList.innerHTML = `<div class="msg-noavailability">${err.message || 'Error occurred'}</div>`;
    }
  }

  loadGoogleMapsAPI() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDRQJdApQPD_PHGDl_mQBiYzuRXYdZ3bzE&callback=initAutocomplete&libraries=places&v=weekly`;
    script.defer = true;
    script.async = true;
    document.head.appendChild(script);

    window.initAutocomplete = this.initAutocomplete.bind(this);
  }

  initAutocomplete() {
    this.address1Field = document.querySelector("#ship-address");
    this.autocomplete = new google.maps.places.Autocomplete(this.address1Field, {
      componentRestrictions: { country: [this.countryCode] },
      fields: ["address_components", "geometry"],
    });

    if (window.location.hash === "#find-in-store") {
      this.address1Field.focus();
    }

    this.autocomplete.addListener("place_changed", this.fillInAddress.bind(this));
  }

  fillInAddress() {
    // let place = this.autocomplete.getPlace();
    // place = JSON.stringify(place);
    // place = JSON.parse(place);

    // const location = {
    //   lat: place.geometry?.location?.lat(),
    //   lng: place.geometry?.location?.lng(),
    // };

    const location = {
      lat: 35.665022,
      lng: 139.70339,
    };

    document.querySelector("#findinstore")?.setAttribute("data-location", JSON.stringify(location));
  }

  sendAppsflyerEvent(event_name, event_value) {
    if (window.navigator.userAgent === 'Yappli') {
        Yappli.sendTrackedEvent(event_name, event_value, function(result, message) {
            if (!result) {
                sendEvent(event_name, event_value);
            }
        })
    }
  }

  // Braze favourite and unfavourite events. Mirrors the add_to_cart payload: the
  // product title, the SKU of the variant currently selected in the form, and
  // the size label built from that variant's options. Only sent when the
  // wishlist button actually switches state.
  sendBrazeFavoriteEvent(eventName, productData) {
    if (!window.logBrazeFavorite) return;

    // Scoped to the main product so quick add forms elsewhere on the page cannot
    // supply the variant.
    const scope = document.querySelector('.main-product') || document;
    const variantId = scope.querySelector("form input[type='hidden'][name='id']")?.value;
    const variant = window.meta?.product?.variants?.find((item) => item.id == variantId);

    const properties = {
      product_name: (productData?.dataset.name || '').trim(),
      sku: variant?.sku || ''
    };
    // Size options are named サイズ, ウエスト or 股下 depending on the product,
    // so read the variant ("34 / 32" -> "3432") instead of the option inputs.
    // public_title is null for a single variant product, which has no size, so
    // the size key is left out entirely.
    if (variant?.public_title) properties.size = variant.public_title.split(' / ').join('');

    window.logBrazeFavorite(eventName, properties);
  }
}

customElements.define('pdp-button-group', PdpButtonGroup);